import React from "react";
import styles from "../../styles/configModal.module.css";

const ConfigModal = ({ config, setConfig, closeModal, initialConfig }) => {
  const handleNestedChange = (keys, value) => {
    setConfig((prevConfig) => {
      const newConfig = JSON.parse(JSON.stringify(prevConfig));
      let current = newConfig;
      for (let i = 0; i < keys.length - 1; i++) {
        current = current[keys[i]];
      }
      current[keys[keys.length - 1]] = value;
      return newConfig;
    });
  };

  const FontSection = ({ type, title }) => (
    <div className={styles.configGroup}>
      <label>{title}:</label>
      <select
        value={config.fonts[type].style}
        onChange={(e) =>
          handleNestedChange(["fonts", type, "style"], e.target.value)
        }
      >
        <option value="times">Times</option>
        <option value="helvetica">Helvetica</option>
        <option value="courier">Courier</option>
      </select>
      <select
        value={config.fonts[type].weight}
        onChange={(e) =>
          handleNestedChange(["fonts", type, "weight"], e.target.value)
        }
      >
        <option value="normal">Normal</option>
        <option value="bold">Bold</option>
        <option value="italic">Italic</option>
        <option value="bolditalic">Bold Italic</option>
      </select>
      <input
        type="number"
        value={config.fonts[type].size}
        onChange={(e) =>
          handleNestedChange(["fonts", type, "size"], Number(e.target.value))
        }
      />
      <input
        type="color"
        value={config.fonts[type].color}
        onChange={(e) =>
          handleNestedChange(["fonts", type, "color"], e.target.value)
        }
      />
    </div>
  );

  return (
    <div className={styles.modalOverlay} onClick={closeModal}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h3>Resume Layout & Style</h3>
          <button onClick={closeModal} className={styles.closeButton}>
            ×
          </button>
        </div>
        <div className={styles.modalBody}>
          <div className={styles.configSection}>
            <h4>Page Settings</h4>
            <div className={styles.configGroup}>
              <label>Format:</label>
              <select
                value={config.page.format}
                onChange={(e) =>
                  handleNestedChange(["page", "format"], e.target.value)
                }
              >
                <option value="a4">A4</option>
                <option value="letter">Letter</option>
              </select>
              <label>Left/Right Margin (mm):</label>
              <input
                type="number"
                value={config.page.margins.left}
                onChange={(e) =>
                  handleNestedChange(
                    ["page", "margins", "left"],
                    Number(e.target.value)
                  )
                }
              />
            </div>
          </div>

          <div className={styles.configSection}>
            <h4>Font Settings</h4>
            <FontSection type="header" title="Header (Name)" />
            <FontSection
              type="sectionHeader"
              title="Section Titles (EDUCATION)"
            />
            <FontSection
              type="sectionTitle"
              title="Entry Titles (IIT Kharagpur)"
            />
            <FontSection type="normal" title="Normal Text (Bullets)" />
            <FontSection type="small" title="Small Text (Degree)" />
          </div>

          <div className={styles.configSection}>
            <h4>Spacing (in mm)</h4>
            <div className={styles.configGroup}>
              <label>Section Gap:</label>
              <input
                type="number"
                step="0.5"
                value={config.spacing.sectionGap}
                onChange={(e) =>
                  handleNestedChange(
                    ["spacing", "sectionGap"],
                    Number(e.target.value)
                  )
                }
              />
              <label>Line Gap:</label>
              <input
                type="number"
                step="0.5"
                value={config.spacing.lineGap}
                onChange={(e) =>
                  handleNestedChange(
                    ["spacing", "lineGap"],
                    Number(e.target.value)
                  )
                }
              />
              <label>Bullet Indent:</label>
              <input
                type="number"
                step="0.5"
                value={config.spacing.indentation}
                onChange={(e) =>
                  handleNestedChange(
                    ["spacing", "indentation"],
                    Number(e.target.value)
                  )
                }
              />
            </div>
          </div>

          <div className={styles.configSection}>
            <h4>Divider Settings</h4>
            <div className={styles.configGroup}>
              <label>Style:</label>
              <select
                value={config.divider.style}
                onChange={(e) =>
                  handleNestedChange(["divider", "style"], e.target.value)
                }
              >
                <option value="line">Line</option>
                <option value="none">None</option>
              </select>
              <label>Color:</label>
              <input
                type="color"
                value={config.divider.color}
                onChange={(e) =>
                  handleNestedChange(["divider", "color"], e.target.value)
                }
              />
              <label>Width:</label>
              <input
                type="number"
                step="0.1"
                value={config.divider.width}
                onChange={(e) =>
                  handleNestedChange(
                    ["divider", "width"],
                    Number(e.target.value)
                  )
                }
              />
            </div>
          </div>
        </div>
        <div className={styles.modalFooter}>
          <button
            onClick={() => setConfig(initialConfig)}
            className={styles.resetButton}
          >
            Reset to Default
          </button>
          <button onClick={closeModal} className={styles.saveButton}>
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfigModal;
